import { Link } from "react-router-dom";
import { Wand2, Shield, Globe, Mail } from "lucide-react";
import { useAuth } from "@/hooks/useAuth";

export const FooterSection = () => {
  const { user } = useAuth();
  return (
    <footer className="bg-card border-t border-border mt-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand Section */}
          <div className="md:col-span-2">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-8 h-8 bg-primary rounded-full flex items-center justify-center">
                <Wand2 className="w-4 h-4 text-primary-foreground" />
              </div>
              <h3 className="text-lg font-bold text-primary">AI Humanizer Text</h3>
            </div>
            <p className="text-muted-foreground mb-4 max-w-md">
              Transform AI-generated content into natural, human-like writing with advanced AI technology. 
              Perfect for content creators, students, and professionals.
            </p>
            {!user && (
              <a href="https://theresanaiforthat.com/ai/ai-humanizer-text/?ref=featured&v=783437" target="_blank" rel="nofollow">
                <img width="300" src="https://media.theresanaiforthat.com/featured-on-taaft.png?width=600" alt="Featured on There's An AI For That" />
              </a>
            )}
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold mb-4">Product</h4>
            <ul className="space-y-3 text-sm text-muted-foreground">
              <li><Link to="/" className="hover:text-primary transition-colors">Humanizer</Link></li>
              <li><Link to="/pricing" className="hover:text-primary transition-colors">Pricing</Link></li>
              <li><Link to="/about" className="hover:text-primary transition-colors">About</Link></li>
              <li><Link to="/auth" className="hover:text-primary transition-colors">Sign Up</Link></li>
            </ul>
          </div>

          {/* Support */}
          <div>
            <h4 className="font-semibold mb-4">Support</h4>
            <ul className="space-y-3 text-sm text-muted-foreground">
              <li><Link to="/help" className="hover:text-primary transition-colors">Help Center</Link></li>
              <li><Link to="/privacy" className="hover:text-primary transition-colors">Privacy Policy</Link></li>
              <li><Link to="/terms" className="hover:text-primary transition-colors">Terms of Service</Link></li>
              <li>
                <a href="mailto:support@aihumanizertext.com" className="hover:text-primary transition-colors flex items-center gap-1">
                  <Mail className="w-3 h-3" />
                  Contact Us
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-border mt-8 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-sm text-muted-foreground">© 2025 AIHumanizerText.com. All rights reserved.</p>
          </div>
        </div>
      </div>
    </footer>
  );
};